<template>
  <!-- 屈光筛查  -->
  <div v-if="model && model.refractive">
    <div id="print_refractive" class="page refractive-page" style="margin:0 auto; border:0px solid #E8E8EC;">
      <div style="height: 50px;"></div>
      <div style="font-size: 18px;"><span>{{ model.refractive.hospitalName ? model.refractive.hospitalName : "" }}</span></div>
      <div style="font-size: 22px;padding: 20px 0 30px 0;font-weight: 600;"><span>{{ model.refractive.reportName ? model.refractive.reportName : "屈光筛查报告" }}</span></div>

      <table style="margin-top: 15px;margin-left: 15px;margin-right: 8px;text-align: left;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">学校：<span>{{ model.refractive.schoolName ? model.refractive.schoolName : ""  }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">年级：<span>{{ model.refractive.gradeName ? model.refractive.gradeName : ""  }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">班级：<span>{{ model.refractive.className ? model.refractive.className : ""  }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">编号：<span>{{ model.refractive.barCode ? model.refractive.barCode : ""  }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">筛查时间：<span>{{ model.refractive.screeningTime ? model.refractive.screeningTime : ""  }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">姓名：<span>{{ model.refractive.name ? model.refractive.name : ""  }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">性别：<span>{{ model.refractive.sex ? model.refractive.sex : ""  }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">年龄：<span>{{ model.refractive.age ? model.refractive.age : ""  }}</span></td>
          </tr>
        </tbody>
      </table>
      <div style="border-bottom:1px solid rgb(14, 14, 14);"></div>

      <table style="text-align: center;margin-top: 10px;margin-left: 15px;padding-top:20px;padding-bottom:20px;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 25px;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">眼睛</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">指标</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">检查结果</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">范围</td>
            <td style="width: 100px;border-collapse: collapse;border:none;border-right: 2px solid rgb(0, 0, 0);">指示</td>
            <td style="width:25px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">眼睛</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">指标</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">检查结果</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">范围</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">指示</td>
          </tr>
          <tr style="line-height: 25px;border:none;">
            <td style="color: rgb(66, 100, 216);width: 100px;border-collapse: collapse;border:none;">右眼</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">s球径<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.rightEyeSBallDiameter ? model.refractive.rightEyeSBallDiameter : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.sballNormalRange ? model.refractive.sballNormalRange : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;border-right: 2px solid rgb(0, 0, 0);"><span>{{ model.refractive.rightEyeSBallDiameterIndication ? model.refractive.rightEyeSBallDiameterIndication : "" }}</span></td>
            <td style="width:25px;border-collapse: collapse;border:none;"></td>

            <td style="color: rgb(66, 100, 216);width: 100px;border-collapse: collapse;border:none;">左眼</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">s球径<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.leftEyeSBallDiameter ? model.refractive.leftEyeSBallDiameter : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.sballNormalRange ? model.refractive.sballNormalRange : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.leftEyeSBallDiameterIndication ? model.refractive.leftEyeSBallDiameterIndication : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">c柱径<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.rightEyeCColumnDiameter ? model.refractive.rightEyeCColumnDiameter : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.cballNormalRange ? model.refractive.cballNormalRange : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;border-right: 2px solid rgb(0, 0, 0);"><span>{{ model.refractive.rightEyeCColumnDiameterIndication ? model.rightEyeCColumnDiameterIndication : "" }}</span></td>
            <td style="width:25px;border-collapse: collapse;border:none;"></td>

            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">c柱径<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.leftEyeCColumnDiameter ? model.refractive.leftEyeCColumnDiameter : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.cballNormalRange ? model.refractive.cballNormalRange : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.leftEyeCColumnDiameterIndication ? model.refractive.leftEyeCColumnDiameterIndication : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">轴位<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.rightEyeTrustTimes ? model.refractive.rightEyeTrustTimes : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;border-right: 2px solid rgb(0, 0, 0);"><span>{{ model.refractive.rightEyeTrustTimesIndication ? model.refractive.rightEyeTrustTimesIndication : "" }}</span></td>
            <td style="width:25px;border-collapse: collapse;border:none;"></td>

            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">轴位<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.leftEyeTrustTimes ? model.refractive.leftEyeTrustTimes : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.refractive.leftEyeTrustTimesIndication ? model.refractive.leftEyeTrustTimesIndication : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <div style="text-align: left;margin-top: 10px;padding-top:10px;padding-left: 15px;padding-bottom:10px;border-bottom:1px solid rgb(14, 14, 14);"></div>

      <table style="margin-top: 10px;margin-left: 15px;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【初筛结果】</p></div>
              <div style="min-height: 20px;"><p>{{ model.refractive.screeningSummary ? model.refractive.screeningSummary : "" }}</p></div>
            </td>
          </tr>
          <tr style="text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【建议】</p></div>
              <div style="min-height: 20px;"><p>{{ model.refractive.recommendations ? model.refractive.recommendations : "" }}</p></div>
            </td>
          </tr>
          <tr style="text-align: left;border:none;">
            <td class="refractive_childrenVisionCareTips" style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【儿童视力保健提示】</p></div>
              <div v-for="(item, index) in model.refractive.childrenVisionCareTips" style="min-height: 20px;"><p>{{ item ? item : "" }}</p></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>
<script>

import {_refractive} from "@/services/report/report";
export default {
  name: "refractiveReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        refractive:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    }
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'refractive'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'refractive') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.refractive(this.barCode);
      }
    },
    refractive(barCode) {
      _refractive({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
      })
    },
  }
};
</script>
<style lang="postcss" scoped>
@media print {
  .refractive-page {
    page: refractive-page; /* 绑定唯一命名 */
  }
  @page refractive-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:10px;padding-left:40px;padding-right:40px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}

</style>
